<template>
  <div :class="{'shaded': isOdd}">

    <b-container fluid>
      <b-row>
        <b-col cols="12" sm="9">
          <div class="header-wrapper">
            <span v-if="isProcedure" class="row-number">
              {{ rowNumber }}
            </span>
            <h4> {{ item.text }} </h4>
          </div>
        </b-col>
        <b-col cols="12" sm="3" class="completed-wrapper">
          <mark-as-completed
            v-if="isProcedure"
            :completed="item.is_complete ? item.is_complete : false"
            class="completed-button"
            @toggled="toggleCompleted"/>
        </b-col>
      </b-row>
    </b-container>

    <template v-for="item in item.children">
      <component
        :key="item.id"
        :item="item"
        :is="'item-' + item.type"/>
    </template>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import itemParagraph from './paragraph'
import itemMediaGroup from './media-group'
import itemImage from './image'
import itemVideo from './video'
import itemPdf from './pdf'
import itemAudio from './audio'
import markAsCompleted from './mark-as-completed'

export default {
  components: {
    itemParagraph,
    itemImage,
    itemMediaGroup,
    itemVideo,
    itemPdf,
    itemAudio,
    markAsCompleted
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    preview: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    isOdd () {
      return this.$store.getters['items/isOddRow'](this.item.id)
    },
    isProcedure () {
      return this.item.is_procedure
    },
    rowNumber () {
      if (this.item.is_procedure) {
        if (this.preview) {
          return this.$store.getters['items/rowNumber']({rowID: this.item.id, editing: true})
        } else {
          return this.$store.getters['items/rowNumber']({rowID: this.item.id, editing: false})
        }
      }

      return null
    },
    ...mapGetters('client', {
      role: 'getCurrentRole'
    })
  },
  methods: {
    toggleCompleted () {
      if (this.preview || this.role === 'owner') {
        return
      }

      if (this.item.is_complete) {
        this.$store.dispatch('items/markIncomplete', {
          itemID: this.item.id
        })
      } else {
        this.$store.dispatch('items/markComplete', {
          itemID: this.item.id
        })
      }

      this.$store.commit('items/toggleComplete', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/stylesheets/main.scss';
@import 'node_modules/bootstrap/scss/bootstrap-grid.scss';

.completed-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.shaded {
  background: $light-secondary;
}

.header-wrapper {
  display: flex;
  align-items: center;
  padding: 1.25rem;

  .row-number {
    background: $dark-grey;
    border-radius: 1rem;
    -moz-border-radius: 1rem;
    -webkit-border-radius: 1rem;
    color: $light-primary;
    display: inline-block;
    line-height: 2rem;
    text-align: center;
    min-width: 2rem;
    margin-right: $spacing-xs;
  }

  h4 {
    margin: 0;
  }
}

@include media-breakpoint-down(xs) {
  .header-wrapper {
    margin-top: $spacing-xs;
    padding: $spacing-xs;
    justify-content: flex-start;
  }

  .completed-wrapper {
    align-items: center;
    justify-content: flex-start;

    >.completed-button {
      margin-left: -4px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/client/items/row.vue